// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "billing/v1/billingadministration.proto" (package "billing.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message billing.v1.SetInvoiceStatusRequest
 */
export interface SetInvoiceStatusRequest {
    /**
     * @generated from protobuf field: string invoice_id = 1;
     */
    invoiceId: string;
    /**
     * @generated from protobuf field: billing.v1.InvoiceStatus status = 2;
     */
    status: InvoiceStatus;
}
/**
 * @generated from protobuf message billing.v1.SetInvoiceStatusResponse
 */
export interface SetInvoiceStatusResponse {
}
/**
 * @generated from protobuf message billing.v1.SuspendOrganizationRequest
 */
export interface SuspendOrganizationRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message billing.v1.SuspendOrganizationResponse
 */
export interface SuspendOrganizationResponse {
}
/**
 * @generated from protobuf message billing.v1.GetOrganizationsWithOverduePaymentsRequest
 */
export interface GetOrganizationsWithOverduePaymentsRequest {
}
/**
 * @generated from protobuf message billing.v1.GetOrganizationsWithOverduePaymentsResponse
 */
export interface GetOrganizationsWithOverduePaymentsResponse {
    /**
     * @generated from protobuf field: repeated billing.v1.OrganizationWithOverduePayment active_organizations = 1;
     */
    activeOrganizations: OrganizationWithOverduePayment[]; // Organizations with overdue bills not yet suspended by Viam's Ops team
    /**
     * @generated from protobuf field: repeated billing.v1.OrganizationWithOverduePayment suspended_organizations = 2;
     */
    suspendedOrganizations: OrganizationWithOverduePayment[]; // Organizations suspended because of their overdue bills
}
/**
 * @generated from protobuf message billing.v1.OrganizationWithOverduePayment
 */
export interface OrganizationWithOverduePayment {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string org_name = 2;
     */
    orgName: string;
    /**
     * The org's billing email, empty if no payment method was ever added.
     *
     * @generated from protobuf field: string primary_owner_email = 3;
     */
    primaryOwnerEmail: string;
    /**
     * @generated from protobuf field: int32 num_days_overdue = 4;
     */
    numDaysOverdue: number;
    /**
     * @generated from protobuf field: int32 num_days_suspended = 5;
     */
    numDaysSuspended: number;
    /**
     * @generated from protobuf field: billing.v1.AmountUSD amount_overdue_usd = 6;
     */
    amountOverdueUsd?: AmountUSD;
    /**
     * @generated from protobuf field: repeated string affiliate_organizations = 7;
     */
    affiliateOrganizations: string[];
    /**
     * Every user with the organization_owner role on the org.
     *
     * @generated from protobuf field: repeated string owner_emails = 8;
     */
    ownerEmails: string[];
}
/**
 * AmountUSD leverages int32 values to avoid floating value truncation.
 *
 * @generated from protobuf message billing.v1.AmountUSD
 */
export interface AmountUSD {
    /**
     * @generated from protobuf field: int32 dollars = 1;
     */
    dollars: number;
    /**
     * @generated from protobuf field: int32 cents = 2;
     */
    cents: number;
}
/**
 * @generated from protobuf message billing.v1.GetOrganizationsByCurrentMonthUsageRequest
 */
export interface GetOrganizationsByCurrentMonthUsageRequest {
    /**
     * @generated from protobuf field: int64 limit = 1;
     */
    limit: string;
    /**
     * @generated from protobuf field: int64 offset = 2;
     */
    offset: string;
}
/**
 * @generated from protobuf message billing.v1.GetOrganizationsByCurrentMonthUsageResponse
 */
export interface GetOrganizationsByCurrentMonthUsageResponse {
    /**
     * Orgs with current month charges, sorted highest first.
     *
     * @generated from protobuf field: repeated billing.v1.OrganizationCurrentMonthUsage organizations = 1;
     */
    organizations: OrganizationCurrentMonthUsage[];
}
/**
 * @generated from protobuf message billing.v1.OrganizationCurrentMonthUsage
 */
export interface OrganizationCurrentMonthUsage {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string org_name = 2;
     */
    orgName: string;
    /**
     * @generated from protobuf field: billing.v1.AmountUSD current_month_usage_usd = 3;
     */
    currentMonthUsageUsd?: AmountUSD;
}
/**
 * @generated from protobuf message billing.v1.PermanentlyDeleteOrganizationRequest
 */
export interface PermanentlyDeleteOrganizationRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message billing.v1.PermanentlyDeleteOrganizationResponse
 */
export interface PermanentlyDeleteOrganizationResponse {
}
/**
 * @generated from protobuf message billing.v1.GetBillableRegistryItemDisbursementsRequest
 */
export interface GetBillableRegistryItemDisbursementsRequest {
    /**
     * 1-12
     *
     * @generated from protobuf field: int32 billing_cycle_month = 1;
     */
    billingCycleMonth: number;
    /**
     * @generated from protobuf field: int32 billing_cycle_year = 2;
     */
    billingCycleYear: number;
    /**
     * Restricts the breakdown to a single registry-item-owner organization. All owner orgs are returned when unset.
     *
     * @generated from protobuf field: optional string registry_item_owner_org_id = 3;
     */
    registryItemOwnerOrgId?: string;
}
/**
 * @generated from protobuf message billing.v1.GetBillableRegistryItemDisbursementsResponse
 */
export interface GetBillableRegistryItemDisbursementsResponse {
    /**
     * @generated from protobuf field: repeated billing.v1.RegistryItemOwnerDisbursement owner_disbursements = 1;
     */
    ownerDisbursements: RegistryItemOwnerDisbursement[];
}
/**
 * @generated from protobuf message billing.v1.RegistryItemOwnerDisbursement
 */
export interface RegistryItemOwnerDisbursement {
    /**
     * @generated from protobuf field: string registry_item_owner_org_id = 1;
     */
    registryItemOwnerOrgId: string;
    /**
     * @generated from protobuf field: string registry_item_owner_org_name = 2;
     */
    registryItemOwnerOrgName: string;
    /**
     * @generated from protobuf field: repeated billing.v1.RegistryItemDisbursement registry_item_disbursements = 3;
     */
    registryItemDisbursements: RegistryItemDisbursement[];
    /**
     * This is the sum of all RegistryItemDisbursement.amount_usd in the field above.
     *
     * @generated from protobuf field: billing.v1.AmountUSD total_amount_usd = 4;
     */
    totalAmountUsd?: AmountUSD;
}
/**
 * @generated from protobuf message billing.v1.RegistryItemDisbursement
 */
export interface RegistryItemDisbursement {
    /**
     * @generated from protobuf field: string registry_item_id = 1;
     */
    registryItemId: string;
    /**
     * The registry item type; only "module" for now.
     *
     * @generated from protobuf field: string registry_item_type = 2;
     */
    registryItemType: string;
    /**
     * Distinct registry_item_cached_name values captured at billing time for this registry item;
     * a registry item renamed mid-cycle yields more than one.
     *
     * @generated from protobuf field: repeated string cached_registry_item_names = 3;
     */
    cachedRegistryItemNames: string[];
    /**
     * @generated from protobuf field: billing.v1.AmountUSD amount_usd = 4;
     */
    amountUsd?: AmountUSD;
}
/**
 * @generated from protobuf message billing.v1.GetInvoicesRequiringManualAttentionRequest
 */
export interface GetInvoicesRequiringManualAttentionRequest {
}
/**
 * @generated from protobuf message billing.v1.GetInvoicesRequiringManualAttentionResponse
 */
export interface GetInvoicesRequiringManualAttentionResponse {
    /**
     * Invoices whose billing tier requires manual handling instead of automated charging.
     * Sorted by (org_id, invoice_start_date) so rows for the same org are contiguous.
     *
     * @generated from protobuf field: repeated billing.v1.InvoiceRequiringManualAttention invoices = 1;
     */
    invoices: InvoiceRequiringManualAttention[];
}
/**
 * @generated from protobuf message billing.v1.InvoiceRequiringManualAttention
 */
export interface InvoiceRequiringManualAttention {
    /**
     * @generated from protobuf field: string invoice_id = 1;
     */
    invoiceId: string;
    /**
     * @generated from protobuf field: string org_id = 2;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string org_name = 3;
     */
    orgName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp invoice_start_date = 4;
     */
    invoiceStartDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp invoice_end_date = 5;
     */
    invoiceEndDate?: Timestamp;
    /**
     * @generated from protobuf field: billing.v1.AmountUSD amount_usd = 6;
     */
    amountUsd?: AmountUSD;
    /**
     * The reason copied from the org's BillableResourceTier at invoice finalization.
     * Currently only "ACH payment" is in use; clients should tolerate other values.
     * It is already a prettily formatted string.
     *
     * @generated from protobuf field: string requires_manual_attention_reason = 7;
     */
    requiresManualAttentionReason: string;
}
/**
 * @generated from protobuf enum billing.v1.InvoiceStatus
 */
export enum InvoiceStatus {
    /**
     * @generated from protobuf enum value: INVOICE_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INVOICE_STATUS_PAID = 1;
     */
    PAID = 1,
    /**
     * @generated from protobuf enum value: INVOICE_STATUS_OUTSTANDING = 2;
     */
    OUTSTANDING = 2,
    /**
     * @generated from protobuf enum value: INVOICE_STATUS_PAYMENT_NOT_REQUIRED = 3;
     */
    PAYMENT_NOT_REQUIRED = 3,
    /**
     * @generated from protobuf enum value: INVOICE_STATUS_PAYMENT_PROCESSING = 4;
     */
    PAYMENT_PROCESSING = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class SetInvoiceStatusRequest$Type extends MessageType<SetInvoiceStatusRequest> {
    constructor() {
        super("billing.v1.SetInvoiceStatusRequest", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "status", kind: "enum", T: () => ["billing.v1.InvoiceStatus", InvoiceStatus, "INVOICE_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.SetInvoiceStatusRequest
 */
export const SetInvoiceStatusRequest = new SetInvoiceStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetInvoiceStatusResponse$Type extends MessageType<SetInvoiceStatusResponse> {
    constructor() {
        super("billing.v1.SetInvoiceStatusResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.SetInvoiceStatusResponse
 */
export const SetInvoiceStatusResponse = new SetInvoiceStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SuspendOrganizationRequest$Type extends MessageType<SuspendOrganizationRequest> {
    constructor() {
        super("billing.v1.SuspendOrganizationRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.SuspendOrganizationRequest
 */
export const SuspendOrganizationRequest = new SuspendOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SuspendOrganizationResponse$Type extends MessageType<SuspendOrganizationResponse> {
    constructor() {
        super("billing.v1.SuspendOrganizationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.SuspendOrganizationResponse
 */
export const SuspendOrganizationResponse = new SuspendOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsWithOverduePaymentsRequest$Type extends MessageType<GetOrganizationsWithOverduePaymentsRequest> {
    constructor() {
        super("billing.v1.GetOrganizationsWithOverduePaymentsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetOrganizationsWithOverduePaymentsRequest
 */
export const GetOrganizationsWithOverduePaymentsRequest = new GetOrganizationsWithOverduePaymentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsWithOverduePaymentsResponse$Type extends MessageType<GetOrganizationsWithOverduePaymentsResponse> {
    constructor() {
        super("billing.v1.GetOrganizationsWithOverduePaymentsResponse", [
            { no: 1, name: "active_organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationWithOverduePayment },
            { no: 2, name: "suspended_organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationWithOverduePayment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetOrganizationsWithOverduePaymentsResponse
 */
export const GetOrganizationsWithOverduePaymentsResponse = new GetOrganizationsWithOverduePaymentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationWithOverduePayment$Type extends MessageType<OrganizationWithOverduePayment> {
    constructor() {
        super("billing.v1.OrganizationWithOverduePayment", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "primary_owner_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "num_days_overdue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "num_days_suspended", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "amount_overdue_usd", kind: "message", T: () => AmountUSD },
            { no: 7, name: "affiliate_organizations", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "owner_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.OrganizationWithOverduePayment
 */
export const OrganizationWithOverduePayment = new OrganizationWithOverduePayment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AmountUSD$Type extends MessageType<AmountUSD> {
    constructor() {
        super("billing.v1.AmountUSD", [
            { no: 1, name: "dollars", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "cents", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.AmountUSD
 */
export const AmountUSD = new AmountUSD$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsByCurrentMonthUsageRequest$Type extends MessageType<GetOrganizationsByCurrentMonthUsageRequest> {
    constructor() {
        super("billing.v1.GetOrganizationsByCurrentMonthUsageRequest", [
            { no: 1, name: "limit", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetOrganizationsByCurrentMonthUsageRequest
 */
export const GetOrganizationsByCurrentMonthUsageRequest = new GetOrganizationsByCurrentMonthUsageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsByCurrentMonthUsageResponse$Type extends MessageType<GetOrganizationsByCurrentMonthUsageResponse> {
    constructor() {
        super("billing.v1.GetOrganizationsByCurrentMonthUsageResponse", [
            { no: 1, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationCurrentMonthUsage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetOrganizationsByCurrentMonthUsageResponse
 */
export const GetOrganizationsByCurrentMonthUsageResponse = new GetOrganizationsByCurrentMonthUsageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationCurrentMonthUsage$Type extends MessageType<OrganizationCurrentMonthUsage> {
    constructor() {
        super("billing.v1.OrganizationCurrentMonthUsage", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_month_usage_usd", kind: "message", T: () => AmountUSD }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.OrganizationCurrentMonthUsage
 */
export const OrganizationCurrentMonthUsage = new OrganizationCurrentMonthUsage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermanentlyDeleteOrganizationRequest$Type extends MessageType<PermanentlyDeleteOrganizationRequest> {
    constructor() {
        super("billing.v1.PermanentlyDeleteOrganizationRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.PermanentlyDeleteOrganizationRequest
 */
export const PermanentlyDeleteOrganizationRequest = new PermanentlyDeleteOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermanentlyDeleteOrganizationResponse$Type extends MessageType<PermanentlyDeleteOrganizationResponse> {
    constructor() {
        super("billing.v1.PermanentlyDeleteOrganizationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.PermanentlyDeleteOrganizationResponse
 */
export const PermanentlyDeleteOrganizationResponse = new PermanentlyDeleteOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillableRegistryItemDisbursementsRequest$Type extends MessageType<GetBillableRegistryItemDisbursementsRequest> {
    constructor() {
        super("billing.v1.GetBillableRegistryItemDisbursementsRequest", [
            { no: 1, name: "billing_cycle_month", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "billing_cycle_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "registry_item_owner_org_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetBillableRegistryItemDisbursementsRequest
 */
export const GetBillableRegistryItemDisbursementsRequest = new GetBillableRegistryItemDisbursementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillableRegistryItemDisbursementsResponse$Type extends MessageType<GetBillableRegistryItemDisbursementsResponse> {
    constructor() {
        super("billing.v1.GetBillableRegistryItemDisbursementsResponse", [
            { no: 1, name: "owner_disbursements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RegistryItemOwnerDisbursement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetBillableRegistryItemDisbursementsResponse
 */
export const GetBillableRegistryItemDisbursementsResponse = new GetBillableRegistryItemDisbursementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegistryItemOwnerDisbursement$Type extends MessageType<RegistryItemOwnerDisbursement> {
    constructor() {
        super("billing.v1.RegistryItemOwnerDisbursement", [
            { no: 1, name: "registry_item_owner_org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registry_item_owner_org_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "registry_item_disbursements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RegistryItemDisbursement },
            { no: 4, name: "total_amount_usd", kind: "message", T: () => AmountUSD }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.RegistryItemOwnerDisbursement
 */
export const RegistryItemOwnerDisbursement = new RegistryItemOwnerDisbursement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegistryItemDisbursement$Type extends MessageType<RegistryItemDisbursement> {
    constructor() {
        super("billing.v1.RegistryItemDisbursement", [
            { no: 1, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registry_item_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cached_registry_item_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "amount_usd", kind: "message", T: () => AmountUSD }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.RegistryItemDisbursement
 */
export const RegistryItemDisbursement = new RegistryItemDisbursement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInvoicesRequiringManualAttentionRequest$Type extends MessageType<GetInvoicesRequiringManualAttentionRequest> {
    constructor() {
        super("billing.v1.GetInvoicesRequiringManualAttentionRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetInvoicesRequiringManualAttentionRequest
 */
export const GetInvoicesRequiringManualAttentionRequest = new GetInvoicesRequiringManualAttentionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInvoicesRequiringManualAttentionResponse$Type extends MessageType<GetInvoicesRequiringManualAttentionResponse> {
    constructor() {
        super("billing.v1.GetInvoicesRequiringManualAttentionResponse", [
            { no: 1, name: "invoices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoiceRequiringManualAttention }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.GetInvoicesRequiringManualAttentionResponse
 */
export const GetInvoicesRequiringManualAttentionResponse = new GetInvoicesRequiringManualAttentionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceRequiringManualAttention$Type extends MessageType<InvoiceRequiringManualAttention> {
    constructor() {
        super("billing.v1.InvoiceRequiringManualAttention", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "org_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "invoice_start_date", kind: "message", T: () => Timestamp },
            { no: 5, name: "invoice_end_date", kind: "message", T: () => Timestamp },
            { no: 6, name: "amount_usd", kind: "message", T: () => AmountUSD },
            { no: 7, name: "requires_manual_attention_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message billing.v1.InvoiceRequiringManualAttention
 */
export const InvoiceRequiringManualAttention = new InvoiceRequiringManualAttention$Type();
/**
 * @generated ServiceType for protobuf service billing.v1.BillingAdministrationService
 */
export const BillingAdministrationService = new ServiceType("billing.v1.BillingAdministrationService", [
    { name: "SetInvoiceStatus", options: {}, I: SetInvoiceStatusRequest, O: SetInvoiceStatusResponse },
    { name: "SuspendOrganization", options: {}, I: SuspendOrganizationRequest, O: SuspendOrganizationResponse },
    { name: "GetOrganizationsWithOverduePayments", options: {}, I: GetOrganizationsWithOverduePaymentsRequest, O: GetOrganizationsWithOverduePaymentsResponse },
    { name: "GetInvoicesRequiringManualAttention", options: {}, I: GetInvoicesRequiringManualAttentionRequest, O: GetInvoicesRequiringManualAttentionResponse },
    { name: "PermanentlyDeleteOrganization", options: {}, I: PermanentlyDeleteOrganizationRequest, O: PermanentlyDeleteOrganizationResponse },
    { name: "GetBillableRegistryItemDisbursements", options: {}, I: GetBillableRegistryItemDisbursementsRequest, O: GetBillableRegistryItemDisbursementsResponse },
    { name: "GetOrganizationsByCurrentMonthUsage", options: {}, I: GetOrganizationsByCurrentMonthUsageRequest, O: GetOrganizationsByCurrentMonthUsageResponse }
]);
